<template>
  <div>
    <div v-if="loading">
      <SpinnerView active color="primary" style="font-size: 3em"/>
    </div>
    <div v-else style="height: 100vh">
      <div class="d-flex flex-row h-100 align-items-stretch">
        <SidenavView v-if="info.user">
          <template v-slot:body>
            <div class="d-flex flex-column align-items-stretch h-100">
              <div class="position-sticky top-0 mb-2" style="z-index: 1">
                <div class="card">
                  <div class="card-body p-1">
                    <div class="d-flex align-items-center g-1 w-100">
                      <CommunitySelectorView class="w-100 overflow-hidden"/>
                      <TargetedModalView v-if="info.community">
                        <template v-slot:target="{ show }">
                          <ButtonView v-if="info.community" type="shaded" color="foreground" style="width: auto" @click="show">
                            <i class="fas fa-magnifying-glass fa-fw"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:header="{ hide }">
                          <div class="d-flex align-items-center justify-content-between">
                            <h3 class="mb-0">{{ translate("search") }}</h3>
                            <ModalCloseButtonView @click="hide"/>
                          </div>
                        </template>
                        <template v-slot:body="{ hide }">
                          <SearchView :community-id="info.community.id" @dismiss="hide"/>
                        </template>
                      </TargetedModalView>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="info.community && route.params.communityId" class="d-flex flex-column g-1">
                <ButtonView v-if="authorization.route({ name: 'community.dashboard' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.dashboard' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-house text-primary fa-fw"></i> {{ translate("home") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.players' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.players' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-users text-info fa-fw"></i> {{ translate("players") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.wiki' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.wiki' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-book text-primary fa-fw"></i> {{ translate("wiki") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.blog' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.blog' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-blog text-success fa-fw"></i> {{ translate("blog") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.applications' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.applications' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-file-contract text-success fa-fw"></i> {{ translate("applications") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.punishments' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.punishments' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-gavel text-danger fa-fw"></i> {{ translate("modules.punishments") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.allowlist' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.allowlist' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-list text-success fa-fw"></i> {{ translate("allowlist") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.support' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.support' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-life-ring text-info fa-fw"></i> {{ translate("support") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.analytics' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.analytics' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-chart-area text-primary fa-fw"></i> {{ translate("analytics") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.automation' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.automation' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-magic-wand-sparkles text-success fa-fw"></i> {{ translate("automation") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.modules.auditLogs' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.modules.auditLogs' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-rectangle-list text-warning fa-fw"></i> {{ translate("audit_logs") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.route({ name: 'community.administration' })" type="shaded" color="foreground" class="w-100" :route="{ name: 'community.administration' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-cog text-primary fa-fw"></i> {{ translate("administration") }}
                  </div>
                </ButtonView>
                <ButtonView type="shaded" color="foreground" class="w-100" @click="openFlexy">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <img src="https://flexy.bot/assets/img/logo.png" style="width: 1em; height: 1em"/>
                    <span>FlexyBot</span>
                  </div>
                </ButtonView>
              </div>
              <div v-else class="d-flex flex-column g-1">
                <ButtonView v-if="authorization.adminRole(adminRoles.superAdmin)" type="shaded" color="foreground" class="w-100" :route="{ name: 'users' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-users fa-fw text-primary"></i> {{ translate("users") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.adminRole(adminRoles.superAdmin)" type="shaded" color="foreground" class="w-100" :route="{ name: 'admin.dashboard' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-dashboard fa-fw text-info"></i> {{ translate("dashboard") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.adminRole(adminRoles.superAdmin)" type="shaded" color="foreground" class="w-100" :route="{ name: 'admin.communities' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-users fa-fw text-primary"></i> {{ translate("communities") }}
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.adminRole(adminRoles.superAdmin)" type="shaded" color="foreground" class="w-100" :route="{ name: 'admin.communities.serverAddons' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-file-alt fa-fw text-warning"></i>
                    <span>{{ translate("server_addons") }}</span>
                  </div>
                </ButtonView>
                <ButtonView v-if="authorization.adminRole(adminRoles.superAdmin)" type="shaded" color="foreground" class="w-100" :route="{ name: 'admin.globalAlert' }">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <i class="fa-duotone fa-warning fa-fw text-warning"></i>
                    <span>{{ translate("alert") }}</span>
                  </div>
                </ButtonView>
                <ButtonView type="shaded" color="foreground" class="w-100" @click="openFlexy">
                  <div class="d-flex align-items-center g-2" style="font-size: 0.9em">
                    <img src="https://flexy.bot/assets/img/logo.png" style="width: 1em; height: 1em"/>
                    <span>FlexyBot</span>
                  </div>
                </ButtonView>
              </div>
              <div class="position-sticky bottom-0 mt-auto">
                <div class="card mt-2">
                  <div class="card-body p-1">
                    <div class="d-flex align-items-center g-1">
                      <ButtonView v-if="info.user" type="shaded" color="foreground" class="w-100 overflow-hidden" :route="{ name: 'user', params: { userId: info.user.id } }">
                        <div class="d-flex align-items-center g-2 overflow-hidden" style="font-size: 0.9em">
                          <AvatarView style="font-size: 1.2em;"/>
                          <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ info.user.name }}</span>
                        </div>
                      </ButtonView>
                      <ButtonView v-if="info.user" type="shaded" color="foreground" @click="viewingNotifications = true">
                        <div class="position-relative">
                          <i class="fas fa-bell fa-fw"></i>
                          <i v-if="notifications.unread" class="fas fa-circle text-danger fa-fw position-absolute top-0 end-0" style="font-size: 0.5em"></i>
                        </div>
                      </ButtonView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </SidenavView>
        <div class="d-flex flex-column w-100 h-100">
          <div class="container">
            <SidenavTopView v-if="info.user" class="mt-4" style="z-index: 1">
              <div class="d-flex justify-content-between align-items-center">
                <CommunitySelectorView/>
                <div class="d-flex align-items-center">
                  <ButtonView type="shaded" color="foreground" @click="viewingNotifications = true">
                    <div class="position-relative">
                      <i class="fas fa-bell fa-fw"></i>
                      <i v-if="notifications.unread" class="fas fa-circle text-danger fa-fw position-absolute top-0 end-0" style="font-size: 0.5em"></i>
                    </div>
                  </ButtonView>
                  <ButtonView type="shaded" color="foreground" @click="sidenav.toggle()">
                    <i class="fas fa-bars fa-fw"></i>
                  </ButtonView>
                </div>
              </div>
            </SidenavTopView>

            <div class="row">
              <div v-if="globalAlert" class="col-12 mt-4">
                <div class="card">
                  <div class="card-body">
                    <RichTextView :content="globalAlert" :features="globalAlertFeatures"/>
                  </div>
                </div>
              </div>
              <div v-if="newerVersionAvailable" class="col-12 mt-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex align-items-center g-4">
                      <i class="fas fa-rotate text-primary" style="font-size: 1.8em"></i>
                      <span>{{ translate("frontendUpdate.description") }}</span>
                    </div>
                    <ButtonView type="normal" color="primary" class="w-100 mt-4" @click="performUpdate">
                      {{ translate('update') }}
                    </ButtonView>
                  </div>
                </div>
              </div>
            </div>
            <RouterView v-slot="{ Component }" class="py-4">
              <component :is="Component" />
            </RouterView>
          </div>
        </div>
      </div>
      <ToastsView/>
      <ModalView v-model:active="viewingNotifications">
        <template v-slot:header>
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="mb-0">{{ translate("notifications") }}</h3>
            <div class="d-flex align-items-center g-3">
              <HttpFormView v-if="notifications.unread" endpoint="notifications/read" method="post" @success="notifications.reload(); notifications.unread = false">
                <template v-slot:form="{ submit, loading }">
                  <ButtonView type="soft" color="primary" size="small" @click="submit">
                    {{ translate("notifications.mark_all_read") }}
                  </ButtonView>
                  <SpinnerView color="primary" :active="loading"/>
                </template>
              </HttpFormView>
              <ModalCloseButtonView @click="viewingNotifications = false"/>
            </div>
          </div>
        </template>
        <template v-slot:body>
          <NotificationsView @dismiss="viewingNotifications = false"/>
        </template>
      </ModalView>
    </div>
  </div>
</template>

<script setup>
import {ToastsView, versionManager, ModalView, HttpFormView, ButtonView, SpinnerView, ModalCloseButtonView, SidenavView, SidenavTopView, TargetedModalView, modal, richTextFeatures, RichTextView} from "@/niftybit";
import info from "@/info";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import AvatarView from "@/components/global/AvatarView.vue";
import authorization from "@/authorization";
import {adminRoles} from "@/systems/main/adminRoles";
import SearchView from "@/systems/community/views/SearchView.vue";
import {useRoute} from "vue-router";
import CommunitySelectorView from "@/components/global/navigation/CommunitySelectorView.vue";
import NotificationsView from "@/systems/notifications/NotificationsView.vue";
import notifications from "@/systems/notifications/notifications";
import sidenav from "@/niftybit/plugins/sidenav/sidenav";

onMounted(() => {
  document.title = "Vactar";
  versionManager.initialize(location.host);
});

onUnmounted(() => {
  versionManager.deinitialize();
});

function performUpdate() {
  versionManager.performUpdate();
}

function openFlexy() {
  window.open("https://flexy.bot", "_blank");
}

const route = useRoute();

const viewingNotifications = ref(false);

const globalAlert = computed(() => info.global.alert);

const loading = computed(() => Object.keys(info.global).length === 0);

const scrollLock = computed(() => modal.count > 0);

watch(scrollLock, () => {
  if (scrollLock.value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
});

const newerVersionAvailable = computed(() => versionManager.newerVersionAvailable !== undefined);

const globalAlertFeatures = [
  richTextFeatures.paragraph.create(),
  richTextFeatures.text.create(),
  richTextFeatures.hardBreak.create(),
  richTextFeatures.heading.create(),
  richTextFeatures.textStyle.create(),
  richTextFeatures.codeBlock.create(),
  richTextFeatures.bulletList.create(),
  richTextFeatures.orderedList.create(),
  richTextFeatures.infoBox.create(),
  richTextFeatures.blockQuote.create(),
  richTextFeatures.textAlign.create(),
  richTextFeatures.code.create(),
  richTextFeatures.strikethrough.create(),
  richTextFeatures.bold.create(),
  richTextFeatures.underline.create(),
  richTextFeatures.italic.create(),
  richTextFeatures.link.create(),
  richTextFeatures.videoEmbed.create(),
];

</script>